module.exports = __webpack_public_path__ + "img/bg_engenharia.1cabb4a9.jpg";